@if (fleet) {
	<nav class="container crumb-bar">
		<a class="crumb-item" [routerLink]="['../../../']">My {{brand.fleetPlural}}</a>
		<span class="crumb-item">&rsaquo;</span>
		<span class="crumb-item active">{{fleet?.fleet_name}}</span>
	</nav>
}
@if (fleet) {
	<app-sticky-header>
		<div class="container">
			<div class="row">
				<div class="col-md-4 col-lg-3 overview">
					<div class="section-title">{{brand.fleetSingular}} Overview</div>
					<div><b>{{brand.fleetSingular}}:</b> {{fleet.fleet_name}}</div>
					<div><b>Number of {{brand.assetPlural}}:</b> <span class="focal">{{fleet.assets.length}}</span></div>
				</div>
				<div class="col-md-8 col-lg-6 overview-buttons mt-sm">
					@if (!allFixed && sortedAssets && sortedAssets.length > 0 && (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master')) {
						<button routerLink="report" class="button small">Usage Report (beta)</button>
					}
					<a class="button small" href="https://support.gpms-vt.com/knowledge">Knowledge Base</a>
					<a class="button small" href="https://support.gpms-vt.com/tickets-view">Customer Portal</a>
				</div>
				<div class="col-lg-3 hide-md overview-sort">
					<div class="w-100">
						<div class="text-muted">Sort by:</div>
						<select class="form-control mt-2" [ngModel]="sortType" (ngModelChange)="sortChange($event)">
							<option value="tail">{{brand.assetName}}</option>
							<option value="type">{{brand.assetSingular}} Type</option>
							<option value="health">Health Overview</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</app-sticky-header>
}

@if (fleet === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading fleet...
	</div>
}

@if (fleet) {
	<div class="container asset-grid">
		@if (!allFixed && !(markers && !markers.length)) {
			<div class="map-panel">
				<div class="h-100">
					@if (!markers) {
						<div class="loading-status">
							<div class="logo-spin"></div>
							Loading...
						</div>
					}
					@if (markers && markers.length) {
						<google-map #googleMap width="100%" height="100%" [options]="mapOptions" (idle)="mapLoaded()">
							@for (marker of markers; track marker) {
								<map-marker (mapClick)="markerClick(marker.mapPoint)" (mapMouseover)="markerMouseover($event, marker)" (mapMouseout)="markerMouseout($event, marker)"
									[position]="marker.mapPoint" [options]="marker.markerOptions" [assetId]="marker.mapPoint.asset_id"></map-marker>
							}
						</google-map>
					}
				</div>
			</div>
		}
		@for (asset of sortedAssets; track asset) {
			<app-asset-summary [asset]="asset" [time_offset_hours]="fleet.time_offset_hours" (mouseenter)="assetHover(asset)" (mouseleave)="assetUnHover(asset)"></app-asset-summary>
		}
	</div>
}